import Vue from 'vue'
import Vuex, { Store, Module } from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/store/types'
import { IReviewEntity, ReviewEntity } from '@/entities'

Vue.use(Vuex)

export const state: IReviewEntity = new ReviewEntity({});
const namespaced: boolean = true;

export const reviewExternal: Module<IReviewEntity, RootState> = {
    namespaced,
    state,
    actions,
    mutations
}
